import development from './development';
import general from './general';
import hive from './hive';

import { DEFAULT_DECORATION, SENTIMENT_TYPE } from 'js/utils/sentiment-question';

/**
 * Stamps every question in a bundled live template as a sentiment scale.
 *
 * The template files themselves stay pure question text and answers, because
 * repeating the same two fields across thirty-odd questions would bury the part
 * that actually differs between them. Likert is now a first-class live type
 * (radio buttons, not thumbs), so these templates must set `type: 'sentiment'`
 * rather than relying on the `"likert"` column default.
 */
function withSentiment(template) {
  return {
    ...template,
    question_sets: template.question_sets.map((questionSet) => ({
      ...questionSet,
      questions: questionSet.questions.map((question) => ({
        ...question,
        type: SENTIMENT_TYPE,
        config: { decoration: DEFAULT_DECORATION },
      })),
    })),
  };
}

const developmentHealthCheck = withSentiment(development);
const generalHealthCheck = withSentiment(general);
const hiveHealthCheck = withSentiment(hive);

export { developmentHealthCheck as development, generalHealthCheck as general, hiveHealthCheck as hive };
